"use client";

import UserContext from "@/context/userContext";
import { saveArticleByUserAPI, savedArticleAPI } from "@/services/followListService";
import { showError, showSuccess } from "@/utils/toast";
import { useContext, useEffect, useState } from "react";

const SaveUnSave = ({ articleId, setSaveCountStatus }) => {
    const [isSaved, setIsSaved] = useState(false);
    const context = useContext(UserContext);
    const user = context.user;

    const handleSaveUnSave = async () => {
        if(!user){
            showError('Please login to save this article');
            return;
        }
        try {
            const response = await savedArticleAPI({ articleId });
            if(response.status === 201 || response.status === 200) {
                showSuccess(response.message);
                setIsSaved(!response.data.removed);
                setSaveCountStatus(!response.data.removed)
            }
        } catch(error){
        }
    }

    // Get Article Saved API
    const getArticleSavedAPI = async () => {
        try {
            const response = await saveArticleByUserAPI({ articleId });
            if(response.status === 200){
                setIsSaved(response.data.saved);
            }
        } catch (error){

        }
    }

    useEffect(() => {
        if(articleId){
            if(user){
                getArticleSavedAPI();
            }
        }
    }, [articleId]);
    
    return (
        <div onClick={handleSaveUnSave}>
        {isSaved ? (
            <svg width="10" height="14" viewBox="0 0 10 14" fill="#919BA1" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.63633 0.532715H1.95383C1.57705 0.532715 1.21571 0.682387 0.949295 0.948806C0.682876 1.21523 0.533203 1.57657 0.533203 1.95334V13.3183L4.79508 11.1874L9.05695 13.3183V1.95334C9.05695 1.57657 8.90728 1.21523 8.64086 0.948806C8.37444 0.682387 8.0131 0.532715 7.63633 0.532715Z" stroke="#75828A" strokeWidth="1.06547" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        ) : (
            <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.63633 0.532715H1.95383C1.57705 0.532715 1.21571 0.682387 0.949295 0.948806C0.682876 1.21523 0.533203 1.57657 0.533203 1.95334V13.3183L4.79508 11.1874L9.05695 13.3183V1.95334C9.05695 1.57657 8.90728 1.21523 8.64086 0.948806C8.37444 0.682387 8.0131 0.532715 7.63633 0.532715Z" stroke="#75828A" strokeWidth="1.06547" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        )}
    </div>
    );
}

export default SaveUnSave;